/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const LogoutIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 24"
    width="25px"
    height="27px"
    className={className}
  >
    <g fillRule="evenodd">
      <path
        stroke="currentColor"
        strokeWidth="0.5"
        fill="currentColor"
        d="M20.68,0H4.54c-.39,0-.7,.31-.7,.7V6.47c0,.39,.31,.7,.7,.7s.7-.31,.7-.7V1.4h14.74V22.6H5.24v-5.06c0-.39-.31-.7-.7-.7s-.7,.31-.7,.7v5.76c0,.39,.31,.7,.7,.7H20.68c.39,0,.7-.31,.7-.7V.7c0-.39-.31-.7-.7-.7Z"
      />
      <path
        stroke="currentColor"
        strokeWidth="0.5"
        fill="currentColor"
        d="M10.7,15c-.27,.27-.27,.72,0,.99,.14,.14,.32,.21,.5,.21s.36-.07,.5-.21l3.5-3.5s.03-.03,.05-.05l.02-.02s.02-.02,.02-.03l.02-.03,.02-.03v-.03l.03-.03v-.03l.02-.03v-.03s.01-.02,.02-.04v-.07s.01-.04,.01-.06h0s0-.05,0-.07v-.07s-.02-.02-.02-.04v-.03l-.02-.03v-.03l-.03-.03v-.03l-.03-.03-.02-.03s-.02-.02-.02-.03l-.02-.02s-.03-.04-.05-.05l-3.5-3.5c-.27-.27-.72-.27-.99,0s-.27,.72,0,.99l2.3,2.3H1.32c-.39,0-.7,.31-.7,.7s.31,.7,.7,.7H13l-2.3,2.3Z"
      />
    </g>
  </svg>
);

export default LogoutIcon;
